import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-delete-roles',
    templateUrl: './delete-roles.component.html',
    styleUrls: ['./delete-roles.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteRolesComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeleteRolesComponent>,
    @Inject(MAT_DIALOG_DATA) public removeRole: any,
    private translocoService: TranslocoService) {
      dialogRef.disableClose = true
    }

    name:string = this.removeRole.data.roleName
    deleteMessage: any = ''
  ngOnInit(): void {
    this.deleteMessage = this.translocoService.translate('accounts.common.deleteConfirm', { name: this.name });
  }

  onSubmit(){ 
    let payload = {
      index: this.removeRole.index,
      roleId: this.removeRole.data.id
    }
    return payload
  }

}
